console.log('Appel Projet single script loaded');

document.addEventListener("DOMContentLoaded", function () {


    function handleSticky(element, container, breadcrumbHeight, formationRightCol) {
        if (!element) return;

        let is_sticky = false;

        const elementTop = element.getBoundingClientRect().top + window.scrollY;
        const elementHeight = element.offsetHeight;
        const containerHeight = container.offsetHeight;

        document.addEventListener("scroll", function () {

            const siteHeader = document.querySelector(".site-header.site-header--sticky");
            if (!siteHeader) return;

            const siteHeaderHeight = siteHeader.offsetHeight + 25;
            const fullHeight = breadcrumbHeight + containerHeight + siteHeaderHeight;

            // Arrivé en bas
            if (window.scrollY + siteHeaderHeight + elementHeight - fullHeight > 0) {
                element.classList.remove("position-fixed");
                element.classList.add("position-fixed-footer");
                is_sticky = false;
            }

            // Sticky actif
            if (
                !is_sticky &&
                elementTop <= window.scrollY + siteHeaderHeight &&
                window.scrollY + siteHeaderHeight + elementHeight - fullHeight < 0
            ) {
                element.classList.add("position-fixed");
                element.classList.remove("position-fixed-footer");

                if (formationRightCol) {
                    formationRightCol.style.position = "relative";
                }

                is_sticky = true;

            } else if (
                is_sticky &&
                elementTop > window.scrollY + siteHeaderHeight
            ) {
                element.classList.remove("position-fixed");
                is_sticky = false;
            }

        });
    }

    if (window.innerWidth > 991) {

        const cardReferent = document.querySelector(".card-referent");
        const decoration = document.querySelector(".single-appel-projet__decoration");
        const formationRightCol = document.querySelector(".single-appel-projet__right-col");
        const container = document.querySelector(".single-appel-projet");
        const breadcrumb = document.querySelector(".breadcrumb");

        if (!container || !breadcrumb) return;

        const breadcrumbHeight = breadcrumb.offsetHeight;

        // 🔥 On applique la fonction aux deux éléments
        handleSticky(cardReferent, container, breadcrumbHeight, formationRightCol);
        // handleSticky(decoration, container, breadcrumbHeight, formationRightCol);
    }

})
